
import { defineComponent } from "vue";
import { get } from "lodash-es";
import * as clipboard from "clipboard-polyfill/text";

export default defineComponent({
  name: "ShareLink",
  data: () => ({
    copied: false,
    errorMessage: "",
    currentHref: window.location.href,
  }),
  watch: {
    $route() {
      this.currentHref = window.location.href;
    },
  },
  methods: {
    copyToClipboard() {
      clipboard.writeText(this.currentHref).then(
        () => {
          this.update();
          const textarea = get(this.$refs, "textarea.$refs.input");
          if (textarea instanceof HTMLTextAreaElement) {
            textarea.focus();
            textarea.select();
          }
        },
        () => {
          this.errorMessage = "Unable to write to clipboard. :-(";
          setTimeout(this.update, 3000);
        }
      );
    },
    update() {
      clipboard.readText().then(
        (text) => {
          this.copied = text === this.currentHref;
          this.errorMessage = "";
        },
        () => {
          // document not focused
        }
      );
    },
  },
});
